import ManagersActionsTab from './ManagersActionsTab';

export default ManagersActionsTab;
